const myEtherWalletInfo = [
  {
    title: "¿Qué es MyEtherWallet (MEW)?",
    value: `
**MyEtherWallet (MEW)** es una de las carteras (wallets) más populares y veteranas del ecosistema Ethereum.  
Permite a los usuarios crear, gestionar y utilizar billeteras Ethereum de forma sencilla, directa y sin custodio (es decir, tú controlas tus llaves privadas).

---

### **¿Para qué se usa MyEtherWallet?**

- **Creación de carteras Ethereum:** Permite generar nuevas wallets (dirección + clave privada) de manera segura.
- **Gestión de fondos:** Puedes recibir, enviar y consultar balances de ETH y tokens ERC-20, ERC-721 (NFTs) y más.
- **Acceso a dApps y contratos:** Interactúa directamente con contratos inteligentes y aplicaciones descentralizadas (dApps).
- **Firmar mensajes y transacciones:** Es posible firmar mensajes para validación de identidad en plataformas Web3.
- **Soporte para hardware wallets:** Compatible con Ledger, Trezor y otras billeteras de hardware para mayor seguridad.
- **Gestión de redes y tokens personalizados:** Puedes agregar manualmente tokens y acceder a redes de prueba (testnets).

---

### **Características principales de MEW**

- **Open Source:** Código abierto y auditado por la comunidad.
- **No custodia:** Las llaves privadas nunca salen de tu dispositivo.
- **Multi-plataforma:** Disponible como sitio web, extensión y app móvil.
- **Compatibilidad:** Opera con múltiples tokens, NFTs y redes.
- **Interfaz intuitiva:** Fácil de usar tanto para principiantes como para usuarios avanzados.
- **Soporte para ENS:** Permite enviar y recibir usando dominios ENS (Ethereum Name Service).
- **Sin KYC:** No requiere registro ni verificación de identidad.
- **Acceso descentralizado:** No depende de un solo servidor, puedes conectarte a diferentes nodos.

---

### **¿Por qué usar MEW?**

- Ideal para gestionar ETH y cualquier token de Ethereum.
- Útil para interactuar con contratos inteligentes, participar en ICOs o airdrops.
- Puedes usarlo como herramienta para firmar y verificar mensajes.
- Seguridad: tus llaves privadas nunca se almacenan en línea.
- Alternativa simple y poderosa a MetaMask o hardware wallets.

---

**Sitio oficial:** [https://www.myetherwallet.com/](https://www.myetherwallet.com/)

![Logo de MEW](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/7-1.png)
`,
    
  }
];

export default myEtherWalletInfo;
